import React, { Component } from 'react';
import { connect } from 'react-redux';
import { resolveLocalizedText } from '../../../../utils';
import { ChangeContactView } from '../../components/ChangeContactView';
import EditableInput from '../../components/EditableInput';
import {
  getChangeEmailLabels,
  getChangeEmailStepContext,
  getIsLoading,
  getFailedPolicies,
} from '../../selectors/changeEmailSelector';
import { getSelectedPolicy } from '../../selectors/changeContactSelector';
import './style.scss';
import { goto } from '../../../../actions/historyActions';
import { getNewEmail } from '../../selectors/changeEmailSelector';
import {
  contactPermissionPolicy,
  changeContactPolicy,
} from '../../types/changeContactService';
import LoadingView from '../../../../components/LoadingView';
import _ from 'lodash';
import EmmaErrorModal from '../../../../components/EmmaErrorModal';

export interface SubmitEmailErrorContainerProps {
  changeEmailLabels: any;
  changeEmailStepContext: any;
  newEmail: string;
  failedPolicies: contactPermissionPolicy[];
  isLoading: boolean;
  selectedPolicy: changeContactPolicy;
}

export interface SubmitEmailErrorContainerState {}

export class SubmitEmailErrorContainer extends Component<
  SubmitEmailErrorContainerProps,
  SubmitEmailErrorContainerState
> {
  state = {};

  tryAgain = () => {
    goto('emma-change-contact');
  };

  componentDidMount() {
    const { selectedPolicy } = this.props;
    if (_.isEmpty(selectedPolicy)) {
      goto('emma-change-contact');
    }
  }

  render() {
    const {
      changeEmailLabels,
      changeEmailStepContext,
      failedPolicies,
      newEmail,
      isLoading,
    } = this.props;
    const editEmail = changeEmailLabels.editEmail
      ? resolveLocalizedText(changeEmailLabels.editEmail)
      : '';
    const resolvedStepContext = resolveLocalizedText(
      changeEmailStepContext,
    ) as any;
    const submitErrorHeading = changeEmailLabels.submitErrorHeading
      ? resolveLocalizedText(changeEmailLabels.submitErrorHeading)
      : '';
    const reviewEmailLabel = changeEmailLabels.reviewEmailLabel
      ? resolveLocalizedText(changeEmailLabels.reviewEmailLabel)
      : '';
    const submitErrorListLabel = changeEmailLabels.submitErrorListLabel
      ? resolveLocalizedText(changeEmailLabels.submitErrorListLabel)
      : '';
    const tryAgainBtn = changeEmailLabels.tryAgainBtn
      ? resolveLocalizedText(changeEmailLabels.tryAgainBtn)
      : '';

    return isLoading ? (
      <LoadingView />
    ) : (
      <div className="Submit-Email-Error">
        <ChangeContactView
          pageName={editEmail}
          stepContext={resolvedStepContext}
          activeIndex={3}
          hideBackButton
        >
          <div className="emma-stylesheet-grid-system">
            <div className="change-contact-heading2">{submitErrorHeading}</div>
            <div className="Submit-Email-Error__editable-input">
              <EditableInput
                label={reviewEmailLabel}
                id="reviewEmailLabel"
                value={newEmail}
                uneditable
                disabled
              />
            </div>
            <div className="change-contact-label--bold">
              {submitErrorListLabel}
            </div>
            <div className="change-contact-label">
              <ul>
                {failedPolicies.map(({ planName, policyName }) => {
                  return (
                    <li>
                      {resolveLocalizedText(planName || policyName || '')}
                    </li>
                  );
                })}
              </ul>
            </div>
            <div className="row">
              <button
                className="Submit-Email-Error__button col-4 emma-stylesheet-primary-default-button"
                data-enable-ga
                data-ga-type="button"
                onClick={this.tryAgain}
              >
                {tryAgainBtn}
              </button>
            </div>
          </div>
        </ChangeContactView>
        <EmmaErrorModal />
      </div>
    );
  }

  static mapStateToProps(state: any, ownProps: any) {
    const changeEmailLabels = getChangeEmailLabels(state);
    const changeEmailStepContext = getChangeEmailStepContext(state);
    const selectedPolicy = getSelectedPolicy(state);
    const newEmail = getNewEmail(state);
    const failedPolicies = getFailedPolicies(state);
    const isLoading = getIsLoading(state);

    return {
      selectedPolicy,
      changeEmailLabels,
      changeEmailStepContext,
      newEmail,
      failedPolicies,
      isLoading,
    };
  }

  static mapDispatchToProps(dispatch: any) {
    return {};
  }
}

export default connect(
  SubmitEmailErrorContainer.mapStateToProps,
  SubmitEmailErrorContainer.mapDispatchToProps,
)(SubmitEmailErrorContainer);
